import { useCallback } from 'react';
import type { CalendarEvent, EventFilter } from '~/src/types/api';
import { getAttendeeEmails, getOrganizerEmail } from '../helpers/calendarEventHelpers';

export const useFilterSelectedEvents = () => {
  return useCallback(
    (
      events: CalendarEvent[],
      activeFilter: EventFilter,
      currentUserEmails: string[],
    ): CalendarEvent[] => {
      switch (activeFilter) {
        case 'host':
          return events.filter((event) => currentUserEmails.includes(getOrganizerEmail(event)));
        case 'participant':
          return events.filter((event) => {
            const organizerEmail = getOrganizerEmail(event);
            const attendeeEmails = getAttendeeEmails(event);

            const isOrganizer = currentUserEmails.includes(organizerEmail);
            const isParticipant = attendeeEmails.some((email) => currentUserEmails.includes(email));

            return !isOrganizer && isParticipant;
          });
        default:
          return events;
      }
    },
    [],
  );
};
